import { Maybe } from 'graphql/jsutils/Maybe';

export const formatCurrency = (
  value: number,
  currency?: string | Maybe<string>,
  padDecimals = false,
): string => {
  const formatOptions = padDecimals
    ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    : ({ trailingZeroDisplay: 'stripIfInteger' } as const);

  return currency
    ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency ?? 'USD',
        ...formatOptions,
      }).format(value)
    : new Intl.NumberFormat('en-US', formatOptions).format(value);
};

export const getCurrencySymbol = (currency?: string | Maybe<string>): string =>
  (0)
    .toLocaleString('en-US', {
      style: 'currency',
      currency: currency ?? 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '');
